<spot-nav [title]="title | titlecase"
  [isSmallNav]="isMobile"
  [isMobile]="isMobile"
  [isBackChevronDT]="true"
  (back)="checkForUnsavedChanges()">
</spot-nav>
<div class="messaging__wrapper">
  <h3 class="messaging__review">Review Message</h3>
  <mat-tab-group class="messaging__tab-group" [selectedIndex]="index" (selectedIndexChange)="tabChanged($event)">
    <mat-tab label="Email">
      <span class="messaging__required-message">Customized message (required)</span>
      <text-box [text]="emailCopy"
        (textChanged)="emailMessageUpdate($event)">
      </text-box>
      @if (emailCopy && emailCopy.length >= emailCharacterLimit) {
        <mat-error>
          10,000 character limit exceeded. Please reduce the message length.
        </mat-error>
      }
    </mat-tab>
    @if (originalAppCopy.length>1) {
      <mat-tab label="Chick-fil-A App">
        <span class="messaging__required-message">Customized message for Chick-fil-A App (required)</span>
        <mat-form-field style="width:100%;">
          <textarea matInput
            maxlength="140"
            #cfaInput
            matAutosizeMinRows="5"
            mdAutoSizeMaxRows="10"
            rows="3"
            class="messaging__textarea"
            [value]="appCopy"
            (keyup)="appMessageUpdate($event)">
          </textarea>
          <mat-hint align="end">{{cfaInput.value.length}} / 140</mat-hint>
        </mat-form-field>
      </mat-tab>
    }

  </mat-tab-group>
  <div [ngClass]="{'messaging__button-container-mobile' : isMobile}">
    <button mat-button (click)="resetAndGoBack()" class="messaging__back-button">
      Back
    </button>
    <button mat-button
      class="messaging__apply-button"
      [disabled]="isInvalid()"
      (click)="apply()">
      Apply
    </button>
  </div>
</div>
